// extracted by mini-css-extract-plugin
export default {"block":"Vl","select":"Wl","empty":"Xl","open":"Yl","error":"Zl","options":"_l","selectActive":"am","ornament":"bm"};